import styled from 'styled-components'

export const Container = styled.div<{ widthDiv: string }>`
  box-sizing: border-box;
  width: ${({ widthDiv }) => widthDiv};
  display: flex;
  flex-direction: column;
  @media screen and (max-width: 480px) {
    width: 100%;
  }
`

export const Label = styled.p<{ isValidate: boolean }>`
  color: ${({ theme }) =>
    ({ isValidate }) => {
      if (isValidate) {
        return theme.colors.primary
      } else {
        return theme.colors.error
      }
    }};
  font-size: ${({ theme }) => theme.fonts.size.normal};
  font-weight: ${({ theme }) => theme.fonts.weight.normal};
  margin: 5px 0;
  @media screen and (max-width: 480px) {
    font-size: ${({ theme }) => theme.fonts.size.superSmall};
  }
`

export const DivSelect = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  padding: 5px 0;
  line-height: 2.2;
  background-color: ${({ theme }) => theme.colors.trueWhite};
  overflow: hidden;
  border: ${({ theme }) => theme.border};
  border-radius: ${({ theme }) => theme.borderRadius.small};

  &::after {
    content: url('/images/icons/arrow.svg');
    position: absolute;
    top: 0;
    right: 0;
    padding: 0 5px;
    background-color: ${({ theme }) => theme.colors.trueWhite};
    cursor: pointer;
    pointer-events: none;
    transition: 0.25s all ease;
  }

  &:hover::after {
    filter: brightness(95%);
  }

  @media screen and (max-width: 720px) {
    label {
      font-size: ${({ theme }) => theme.fonts.size.small};
      margin-bottom: 3px;
    }
  }

  @media screen and (max-width: 480px) {
    label {
      font-size: ${({ theme }) => theme.fonts.size.superSmall};
      margin-bottom: 1.5px;
    }
  }
`
export const SelectComp = styled.select`
  -webkit-appearance: none;
  -moz-appearance: none;
  -ms-appearance: none;
  appearance: none;
  outline: 0;
  box-shadow: none;
  border: 0 !important;
  background-color: ${({ theme }) => theme.colors.trueWhite};
  background-image: none;

  &::-ms-expand {
    display: none;
  }

  flex: 1;
  padding: 0 0.5em;
  color: ${({ theme }) => theme.colors.darkPrimary};
  cursor: pointer;
`
